// Get Monthly Collections Summary Constants
export const GET_MONTHLY_COLLECTIONS_SUMMARY_REQUEST = 'GET_MONTHLY_COLLECTIONS_SUMMARY_REQUEST'
export const GET_MONTHLY_COLLECTIONS_SUMMARY_SUCCESS = 'GET_MONTHLY_COLLECTIONS_SUMMARY_SUCCESS'
export const GET_MONTHLY_COLLECTIONS_SUMMARY_FAIL = 'GET_MONTHLY_COLLECTIONS_SUMMARY_FAIL'
export const GET_MONTHLY_COLLECTIONS_SUMMARY_RESET = 'GET_MONTHLY_COLLECTIONS_SUMMARY_RESET'

// Get Monthly Recovery Collections Constants
export const GET_MONTHLY_RECOVERY_COLLECTIONS_REQUEST = 'GET_MONTHLY_RECOVERY_COLLECTIONS_REQUEST'
export const GET_MONTHLY_RECOVERY_COLLECTIONS_SUCCESS = 'GET_MONTHLY_RECOVERY_COLLECTIONS_SUCCESS'
export const GET_MONTHLY_RECOVERY_COLLECTIONS_FAIL = 'GET_MONTHLY_RECOVERY_COLLECTIONS_FAIL'
export const GET_MONTHLY_RECOVERY_COLLECTIONS_RESET = 'GET_MONTHLY_RECOVERY_COLLECTIONS_RESET'

// Get Monthly Flow Collections Constants
export const GET_MONTHLY_FLOW_COLLECTIONS_REQUEST = 'GET_MONTHLY_FLOW_COLLECTIONS_REQUEST'
export const GET_MONTHLY_FLOW_COLLECTIONS_SUCCESS = 'GET_MONTHLY_FLOW_COLLECTIONS_SUCCESS'
export const GET_MONTHLY_FLOW_COLLECTIONS_FAIL = 'GET_MONTHLY_FLOW_COLLECTIONS_FAIL'
export const GET_MONTHLY_FLOW_COLLECTIONS_RESET = 'GET_MONTHLY_FLOW_COLLECTIONS_RESET'


// Make sure you have these constants for the frontend actions
export const GET_ALL_MONTHLY_COLLECTIONS_REQUEST = 'GET_MONTHLY_COLLECTIONS_SUMMARY_REQUEST';
export const GET_ALL_MONTHLY_COLLECTIONS_SUCCESS = 'GET_MONTHLY_COLLECTIONS_SUMMARY_SUCCESS';
export const GET_ALL_MONTHLY_COLLECTIONS_FAIL = 'GET_MONTHLY_COLLECTIONS_SUMMARY_FAIL';
export const GET_ALL_MONTHLY_COLLECTIONS_RESET = 'GET_MONTHLY_COLLECTIONS_SUMMARY_RESET';